import initialState from './initialState';
import * as types from '../actions/billAcceptorActions/actionTypes';

export default function billAcceptorReducer(state = initialState.billAcceptor, action){
  switch(action.type){
    case types.SET_BILL_ACCEPTOR_BUSY:
      return Object.assign({}, state, {
        isBusy: action.isBusy
      })

    case 'CANCEL_OPERATION':
      return initialState.billAcceptor

    default:
      return state;
  }
}
